module.exports = __webpack_public_path__ + "img/site_type_img_12.954b6612.png";